// extracted by mini-css-extract-plugin
export default {"ranger":"Videos_ranger__jGElw","container":"Videos_container__NMWxt"};